module.exports = __webpack_public_path__ + "static/media/logo_text.b1e66b2c.png";